// extracted by mini-css-extract-plugin
export default {"EmptyBranchesItem":"EmptyBranchesItem3PKOME_zL56m"};